module.exports = __webpack_public_path__ + "img/normal.086985b6.png";